import { getSingleWallRuleSet } from './SingleWallRulesSet';
export const getAutofillRecommendationFromDataSet = (products, frameDepth, design, frameHeight, slidingDoors, wallWidth) => {
    const frameProducts = products
        .filter(p => p.communicatedDimensions.depth === frameDepth &&
        p.communicatedDimensions.height === frameHeight)
        .filter(p => (design ? p.design === design : true));
    const frameSet = getSingleWallRuleSet(wallWidth, slidingDoors);
    let positionCounter = 0;
    const theFrames = frameSet &&
        frameSet.reduce((result, frameWidth) => {
            const product = frameProducts.find(fp => fp.communicatedDimensions.width === frameWidth);
            if (product) {
                result.push({ frame: product, position: { x: positionCounter, y: 0 } });
                positionCounter += frameWidth;
            }
            return result;
        }, []);
    return theFrames;
};
//# sourceMappingURL=AutofillRuleSet.js.map